import { render } from "./MenuSide.vue?vue&type=template&id=24cb1210&scoped=true"
import script from "./MenuSide.vue?vue&type=script&lang=js"
export * from "./MenuSide.vue?vue&type=script&lang=js"

import "./MenuSide.vue?vue&type=style&index=0&id=24cb1210&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cb1210"]])

export default __exports__